import { BASE_LIGHT_THEME as r } from "./index.es5528.js";
import { getContrastRatio as o } from "./index.es550.js";
const m = (a, i) => {
  const t = i === "inner" ? a : r.background.hover;
  return o(t, r.text.primary) > o(t, r.primary.white) ? "primary" : "white";
};
export {
  m as getTextColorByBarColor
};
//# sourceMappingURL=index.es2430.js.map
